<template>
    <button>
        <svg class="hover:fill-[rgb(99,99,99)]" xmlns="http://www.w3.org/2000/svg" height="25" viewBox="0 -960 960 960" fill="green" width="25"><path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"/></svg>
    </button>
</template>